import { dutyTypeList } from "constants/dutyType";

const initialState = {
  dutyTypeList: {},
};

const dutyType = (state = initialState, action) => {
  switch (action.type) {
    case dutyTypeList:
      return { ...state, dutyTypeList: action.payload };

    default:
      return state;
  }
};
export default dutyType;
